import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import { DashboardPresenter } from '@/app/ui/presenters/DashboardPresenter'
import { Dashboard } from '@/domain/entities/Dashboard'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface DashboardState {
  dashboardData: Dashboard
  isLoading: boolean
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'Dashboard' })
class Dashboards extends VuexModule implements DashboardState {
  public dashboardData = new Dashboard(true, '')
  public isLoading = true
  public paginationParam = {}

  @Action
  public async getDashboardData() {
    this.setLoading(true)
    const presenter = await container.resolve(DashboardPresenter)
    presenter
      .loadDashboard(this.paginationParam)
      .then((res: Dashboard) => {
        this.setLoading(false)
        this.setDashboardData(res)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
  }

  @Mutation
  private setDashboardData(dashboard: Dashboard) {
    this.dashboardData = dashboard
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
}

export const DashboardModule = getModule(Dashboards)
